// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"759":"b770a9ac81c93b06","4300":"f8308652dd6a48cb","7821":"d9c36e51dc4707d3","9520":"1ae3d44b213e9e3a"}[chunkId] + ".js";
};